import { render, staticRenderFns } from "./ConvenioDetalles.vue?vue&type=template&id=05761eaa&scoped=true"
import script from "./ConvenioDetalles.vue?vue&type=script&lang=js"
export * from "./ConvenioDetalles.vue?vue&type=script&lang=js"
import style0 from "./ConvenioDetalles.vue?vue&type=style&index=0&id=05761eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05761eaa",
  null
  
)

export default component.exports